
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TwoBlockContentBlockFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TwoBlockContentBlock"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blockReference"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"applyBorder"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"applyBoxShadow"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"additionalStyles"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdditionalStylesFields"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"singleColumnDetails"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subheader"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"header"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"body"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ebookSignUp"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"leadSource"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subscriptionId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"selectTextColor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"imageAsset"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAssetFields"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"videoSource"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VideoSourceFields"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"optionalCta"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CtaButtonFields"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"customIconList"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomIconListFields"},"directives":[]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"blockStyle"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BlockStyleFields"},"directives":[]}]}}]}}],"loc":{"start":0,"end":867}};
    doc.loc.source = {"body":"#import \"../BlockStyleFields.graphql\"\n#import \"../CtaButtonFields.graphql\"\n#import \"../ImageAssetFields.graphql\"\n#import \"../AdditionalStylesFields.graphql\"\n#import \"../VideoSourceFields.graphql\"\n#import \"../CustomIconListFields.graphql\"\n\nfragment TwoBlockContentBlockFields on TwoBlockContentBlock {\n  blockReference {\n    applyBorder\n    applyBoxShadow\n    additionalStyles {\n      ...AdditionalStylesFields\n    }\n    singleColumnDetails {\n      subheader\n      header\n      body\n      ebookSignUp\n      leadSource\n      subscriptionId\n      selectTextColor\n      backgroundColor\n      imageAsset {\n        ...ImageAssetFields\n      }\n      videoSource {\n        ...VideoSourceFields\n      }\n      optionalCta {\n        ...CtaButtonFields\n      }\n      customIconList {\n        ...CustomIconListFields\n      }\n    }\n  }\n  blockStyle {\n    ...BlockStyleFields\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("../BlockStyleFields.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("../CtaButtonFields.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("../ImageAssetFields.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("../AdditionalStylesFields.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("../VideoSourceFields.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("../CustomIconListFields.graphql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["TwoBlockContentBlockFields"] = oneQuery(doc, "TwoBlockContentBlockFields");
        
